import React from 'react';
import media from '../consts/media';

const MediaIcon = ({ name }) => {
  return (
    <a href={media[name]} className="media" target="_blank" rel="noopener noreferrer">
      <img src={`/images/icons/${name}.svg`} alt={name} className="media__icon"/>
    </a>
  );
};

export default MediaIcon;